export default __webpack_public_path__ + "static/media/one.d56033e2.png";